/**
 * @generated SignedSource<<d62e524846e4a4fbfdb24064e9a2882f>>
 * @relayHash bfac5bcd27aeada23cd69a482e5f987f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1f188fcb4a9e41becef087e9550e84163d2d7c12b335d6dc8730860e3e08c584

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSortOrder = "CREATED_DATE_ASCENDING" | "CREATED_DATE_DESCENDING" | "%future added value";
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
export type helpCentersManagementPageQuery$variables = {
  NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: number;
  SORT_ORDER: HelpCenterSortOrder;
  cloudId: string;
  filterType?: HelpCenterType | null;
  workspaceAri: string;
};
export type helpCentersManagementPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpCentersManagementPageFragment">;
};
export type helpCentersManagementPageQuery = {
  response: helpCentersManagementPageQuery$data;
  variables: helpCentersManagementPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SORT_ORDER"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "workspaceAri",
  "variableName": "workspaceAri"
},
v7 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "filterType"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
  },
  {
    "kind": "Variable",
    "name": "sortOrder",
    "variableName": "SORT_ORDER"
  },
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "slug"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "helpCentersManagementPageQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH",
            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
          },
          {
            "kind": "Variable",
            "name": "SORT_ORDER",
            "variableName": "SORT_ORDER"
          },
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "filterType",
            "variableName": "filterType"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "helpCentersManagementPageFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "helpCentersManagementPageQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/)
        ],
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "HelpCenterQueryResultConnection",
            "kind": "LinkedField",
            "name": "helpCenters",
            "plural": false,
            "selections": [
              {
                "concreteType": "HelpCenterQueryResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v10/*: any*/),
                          {
                            "concreteType": "HelpCenterName",
                            "kind": "LinkedField",
                            "name": "name",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "default"
                              },
                              {
                                "concreteType": "HelpCenterTranslation",
                                "kind": "LinkedField",
                                "name": "translations",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "locale"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              }
                            ]
                          },
                          (v11/*: any*/),
                          {
                            "concreteType": "HelpCenterBranding",
                            "kind": "LinkedField",
                            "name": "helpCenterBranding",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isBannerAvailable"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "useDefaultBanner"
                              },
                              {
                                "concreteType": "HelpCenterBrandingColors",
                                "kind": "LinkedField",
                                "name": "colors",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "primary"
                                  }
                                ]
                              },
                              {
                                "concreteType": "HelpCenterBanner",
                                "kind": "LinkedField",
                                "name": "banner",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastUpdated"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mappedProjectsCount"
                          }
                        ],
                        "type": "HelpCenter"
                      },
                      (v12/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v7/*: any*/),
            "filters": [
              "filter"
            ],
            "handle": "connection",
            "key": "helpCentersManagementPageFragment_helpCenters",
            "kind": "LinkedHandle",
            "name": "helpCenters"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1f188fcb4a9e41becef087e9550e84163d2d7c12b335d6dc8730860e3e08c584",
    "metadata": {},
    "name": "helpCentersManagementPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "767d192c1eee830ece678d269a62c024";

export default node;
